import { defineComponent } from "vue";
import { brandDocument } from "@/brand";

import { COMPONENT_NAME } from "./attributes";

export default defineComponent({
  name: COMPONENT_NAME,
  computed: {
    displayedHref(): string {
      return brandDocument(this.href);
    },
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    to: {
      type: String,
      default: "/",
    },
    view: {
      type: String,
      default: "",
    },
    href: {
      type: String,
      default: "",
    },
    target: {
      type: String,
      default: "",
    },
    download: {
      type: Boolean,
      default: false,
    },
  },
});
